export class DateInterval {
	start: Date;

	end: Date | null;

	constructor(start: Date, end: Date | null) {
		this.start = start;
		this.end = end;
	}

	includes(date: Date): boolean {
		return this.start.getTime() <= date.getTime() && (this.end === null || date.getTime() <= this.end.getTime());
	}

	forEachDay(callback: (date: Date) => void) {
		const end = this.end !== null ? this.end : new Date();
		const currentDate = new Date(this.start);

		while (currentDate.getTime() <= end.getTime()) {
			callback(new Date(currentDate));
			currentDate.setDate(currentDate.getDate() + 1);
		}
	}

	forEachMonth(callback: (date: Date) => void) {
		const end = this.end !== null ? this.end : new Date();
		const currentDate = new Date(this.start);

		while (currentDate.getTime() <= end.getTime()) {
			callback(new Date(currentDate));
			currentDate.setMonth(currentDate.getMonth() + 1);
		}
	}
}
